'use strict';

export default class Sitemap {
    constructor() {
        let $sitemap = $('.sitemap');

        {
            if(!$sitemap.length) return;

            $sitemap.children().each(function(){
                let $this = $(this),
                    $yearEl = $this.children('span'),
                    $issuesList = $('ul', $this);

                $yearEl.on('click', function(e){
                    e.preventDefault();

                    if(!$this.hasClass('expand')) {
                        $issuesList.slideDown();
                        $this.addClass('expand');
                    } else {
                        $issuesList.slideUp();
                        $this.removeClass('expand');
                    }
                });

                if($this.index() === 0) {
                    $issuesList.slideDown();
                    $this.addClass('expand');
                }
            })
        }
    }
}
